export default __webpack_public_path__ + "static/media/katz.4f677281.png";